import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  catchError,
  EMPTY,
  finalize,
  Observable,
  shareReplay,
  switchMap,
} from 'rxjs';
import { ApiEndpoints } from '../../services/api.constant';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../service/authentication.service';

export class LocationInterceptor implements HttpInterceptor {
  private readonly http = inject(HttpClient);
  private readonly authenticationService = inject(AuthenticationService);
  private preRequest$: Observable<any> | null = null;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('verify-driver-location'))
      return next.handle(request);

    if (!this.preRequest$) {
      const currentUser = this.authenticationService.currentUserValue;
      if (currentUser)
        this.preRequest$ = this.http
          .get(
            `${environment.mainapiUrl}/${ApiEndpoints.Identity.VerifyDriverLocation}/${currentUser.employeeId}/${currentUser.locationId}`,
          )
          .pipe(
            shareReplay(1),
            finalize(() => (this.preRequest$ = null)),
          );
    }
    return (
      this.preRequest$?.pipe(
        switchMap(response => {
          if (response.data) return next.handle(request);
          else {
            this.authenticationService.logout();
            return EMPTY;
          }
        }),
        catchError(error => {
          if (error.status === 401) {
            this.authenticationService.logout();
          }
          console.log(`Error in API request ${request.url}`, error);
          return EMPTY;
        }),
      ) ?? next.handle(request)
    );
  }
}
